"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = require("prop-types");

var _constant = require("../Theme/constant");

var _constant2 = require("../AdsPlaceholder/constant");

var AdButlerAdsPropTypes = {
  PropTypes: {
    imgUrl: _propTypes.string.isRequired,
    altText: _propTypes.string,
    target: _propTypes.string,
    width: _propTypes.string,
    height: _propTypes.string,
    trackingPixel: _propTypes.string,
    redirectUrl: _propTypes.string.isRequired,
    refreshUrl: _propTypes.string,
    customProperties: _propTypes.object,
    accessible: _propTypes.bool,
    theme: _propTypes.string,
    children: _propTypes.node
  },
  DefaultProps: {
    imgUrl: _constant2.DEFAULT_IMAGE.PRIME.DESKTOP,
    altText: '',
    target: '_blank',
    width: 'auto',
    height: 'auto',
    trackingPixel: '',
    refreshUrl: '',
    accessible: true,
    theme: _constant.DEFAULT_THEME
  }
};
var _default = AdButlerAdsPropTypes;
exports.default = _default;